<template lang='pug'>
  v-dialog(v-model="resetDialog" persistent max-width="450")
    template(v-slot:activator="{ on, attrs }")
        v-btn(
            slot="activator" 
            v-bind="attrs"
            v-on="on"
            class="elevation-0 custom__padding-btn"
            dark
            color="#043E78"
        ) Reset

    v-card(class="pa-5")
      v-icon(class="notif") info
      v-card-title(class="headline") Are you sure to reset this setting?
      v-card-text Please press yes button if you want to reset your system settings.

      v-card-actions(class="mt-5")
        v-spacer

        v-btn(
            @click="resetDialog = false"
            class="custom__padding-btn elevation-0 mr-2"
        ) NO

        v-btn(
            color="blue-secondary",
            @click="reset()"
            class="elevation-0 custom__padding-btn"
        ) YES

    v-overlay(:value="overlay")
      v-progress-circular(
        indeterminate
        size="64"
      )

</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
export default {
  name: 'ResendSetting',
  props: {
    bu_id: String,
  },
  data: () => ({
    resetDialog: false,
    overlay: false,
    setting: {
        bu: null,
        email: null,
        logo: null,
        color: "#D42A2A",
        footer_notif: null,
        reminder_approval_days: null,
        reminder_approval_time: null,
        icon_approve: null,
        icon_reject: null,
        icon_withdraw: null,
        wm_full_approve: null,
        wm_reject: null,
        wm_on_approval: null,
        wm_withdraw: null,
        wm_draft: null,
    },
    preview_logo: {
        url: null,
        name: null
    },
    preview_icon_approve: {
        url: null,
        name: null,
    },
    preview_icon_reject: {
        url: null,
        name: null
    },
    preview_icon_withdraw: {
        url: null,
        name: null,
    },
    preview_wm_full_approve: {
        position: "right",
        rotate: true,
        size: "large",
        name: null,
        url: null
    },
    preview_wm_reject: {
        position: "right",
        rotate: true,
        size: "large",
        name: null,
        url: null
    },
    preview_wm_on_approval: {
        position: "right",
        rotate: true,
        size: "large",
        name: null,
        url: null
    },
    preview_wm_draft: {
        position: "right",
        rotate: true,
        size: "large",
        name: null,
        url: null
    },
    preview_wm_withdraw: {
        position: "right",
        rotate: true,
        size: "large",
        name: null,
        url: null
    },
  }),
  methods: {
    reset() {
        this.overlay = true;

        this.setting.bu = this.bu_id

        this.$store.dispatch("updateDataSetting", {
            setting: this.setting,
            preview_logo: this.preview_logo,
            preview_wm_full_approve: this.preview_wm_full_approve,
            preview_wm_on_approval: this.preview_wm_on_approval,
            preview_wm_reject: this.preview_wm_reject,
            preview_wm_draft: this.preview_wm_draft,
            preview_wm_withdraw: this.preview_wm_withdraw, 
            preview_icon_approve: this.preview_icon_approve,
            preview_icon_reject: this.preview_icon_reject,
            preview_icon_withdraw: this.preview_icon_withdraw
        })
        .then((res) => {
            this.overlay = false;
            if (this.showDrawer) this.$store.commit("toggleDrawer");

            if( this.$store.state.dataUsers.user.hasOwnProperty('default_bu') && this.$store.state.dataUsers.role != "super_user") {
                if ( this.$store.state.dataUsers.user.default_bu == res.data.data._id ) {
                    this.$store.commit("setThemeColor", res.data.data.settings.themeColors)
                    this.$store.commit("setLogo", res.data.data.settings.headerLogo.src != null ? res.data.data.settings.headerLogo.src : require('../assets/imemo-white-text.png'))
                }
            }
            this.$toasted.success("Data updated successfully", {
                icon: "check_circle",
            });
            
            this.resetDialog = false
            setTimeout(function(){
                window.location.reload();
            }, 500);
        })
        .catch((err) => {
            this.overlay = false;
            this.$toasted.error(err.response.data.message, { icon: "error" });
        });
    },
  }
};
</script>

<style>
    i.notif{
        margin-left: 1rem;
        font-size: 50px !important;
        color: #1976D2 !important;
    }
</style>